import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

const AgentsView = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const agent = location.state?.agent;
  const [status, setStatus] = useState(agent?.status ?? true);

  if (!agent) {
    return (
      <div className="p-6">
        <p>No agent selected.</p>
        <button
          onClick={() => navigate("/sales-agents")}
          className="mt-4 px-4 py-2 bg-blue-500 text-white rounded"
        >
          Back
        </button>
      </div>
    );
  }

  return (
    <div className="p-6 bg-white rounded-xl shadow w-1/2 mx-auto">
      <h2 className="text-xl font-semibold mb-4">Agent Details</h2>

      <p><strong>Name:</strong> {agent.name}</p>
      <p><strong>Phone:</strong> {agent.phone}</p>
      <p><strong>Email:</strong> {agent.email}</p>
      <div className="mt-4">
          <label className="block font-medium mb-1">Status</label>
          <select
            value={status ? "true" : "false"}
            onChange={(e) => setStatus(e.target.value === "true")}
            className="w-full px-3 py-2 border rounded-lg"
          >
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>
      <p><strong>Duration:</strong> {agent.duration}</p>
      <p><strong>Target:</strong> {agent.target}</p>
      <p><strong>Salary:</strong> {agent.salary}</p>
     
      <button
        onClick={() => navigate(-1)}
        className="mt-6 px-4 py-2 bg-gray-200 rounded"
      >
        Back
      </button>
    </div>
  );
};

export default AgentsView;
